import { Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function ActivitiesHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const cards = [
    { path: '/education/activities/list', title: t('activityCatalogue'), desc: t('activityCatalogueIntro') },
    {
      path: '/education/activities/meetings',
      title: t('activityMeetings'),
      desc: t('activityMeetingsIntro'),
    },
    {
      path: '/education/activities/achievements',
      title: t('activityAchievements'),
      desc: t('activityAchievementsIntro'),
    },
    {
      path: '/education/activities/memberships',
      title: t('activityMemberships'),
      desc: t('activityMembershipsIntro'),
    },
    {
      path: '/education/activities/memberships/new',
      title: t('enrollActivityMember'),
      desc: t('enrollActivityMemberIntro'),
    },
    {
      path: '/education/activities/memberships/bulk',
      title: t('bulkActivityEnrollment'),
      desc: t('bulkActivityEnrollmentIntro'),
    },
  ];
  return (
    <EducationPageChrome title={t('activities')} description={t('activitiesIntro')}>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={8} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
